import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const ReportSectionSkeleton: FC = () => {
  return (
    <div className="tw-mb-8">
      <div
        style={{
          breakInside: 'avoid',
          breakBefore: 'page',
          pageBreakBefore: 'always',
          paddingBottom: '12px',
        }}
      >
        <div className="tw-flex tw-flex-1 tw-justify-between tw-border-b tw-border-grayscale-20 tw-pb-4">
          <div className="tw-flex tw-items-center tw-gap-4">
            <Skeleton width={52} height={52} borderRadius={8} />
            <div>
              <Skeleton width={240} height={16} className="tw-mb-1" />
              <div className="tw-flex tw-items-center tw-gap-3">
                <Skeleton circle width={24} height={24} />
                <Skeleton width={80} height={16} />
              </div>
            </div>
          </div>
          <div className="tw-flex tw-flex-col tw-items-center">
            <Skeleton width={100} height={16} className="tw-mb-1" />
            <Skeleton width={150} height={16} />
          </div>
        </div>
        <div className="tw-mt-2">
          <Skeleton width={140} height={24} />
        </div>
      </div>

      <div className="tw-grid tw-grid-cols-2 tw-gap-4">
        <Skeleton height={240} />
        <Skeleton height={240} />
        <Skeleton height={240} />
        <Skeleton height={240} />
      </div>
    </div>
  );
};

export default ReportSectionSkeleton;
